import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { remove } from 'lodash';
import { RefSituation } from 'src/app/data/declaration/models/ref-situation.model';
import { RefSituationService } from 'src/app/data/declaration/services/parcellaire/ref-situation.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-liste-situations',
    templateUrl: './liste-situations.component.html',
    styleUrls: ['./liste-situations.component.scss'],
    standalone: false
})
export class ListeSituationsComponent implements OnInit {
    situations: RefSituation[];

    constructor(
        private readonly loaderService: LoaderService,
        private readonly modalsService: ModalService,
        private readonly translate: TranslateService,
        private readonly situationService: RefSituationService,
        private readonly router: Router,
        private readonly route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.situationService
            .getRefSituation()
            .pipe(this.loaderService.operator())
            .subscribe(situations => {
                this.situations = situations;
            });
    }

    openConfirmationDialog(situation: RefSituation) {
        this.modalsService
            .confirm('Veuillez confirmer', 'Voulez vous supprimer la situation ' + situation.libelle + ' ?', {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(() => {
                this.deleteSituation(situation);
            });
    }

    deleteSituation(situation: RefSituation) {
        this.situationService.desactiverRefSituation(situation).subscribe(() => {
            remove(this.situations, situation);
        });
    }

    editSituation(situation: RefSituation) {
        this.modalsService
            .confirm('Veuillez confirmer', this.translate.instant('page.valeur_parametrable.message_modification'), {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(() => {
                this.router.navigate(['edit', situation.id], { relativeTo: this.route });
            });
    }
}
